<div class="tw-container tw-max-w-sm tw-pt-20 tw-pb-5">
  @if(user) {
  <form #form="ngForm" class="uw-fields-container">
    @if(user.profile) {
    <mat-card>
      <mat-card-content>
        <div class="tw-font-bold">Dear {{user.profile['firstName'] || user.profile['name'] || 'customer'}},</div>
        <div>
          Thank you for registering with us. Please fill in the following details to complete your profile.
        </div>
      </mat-card-content>
    </mat-card>
    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput id="email" name="email" [(ngModel)]="user.email" disabled />
    </mat-form-field>
    @if(user.isEmailVerified) {
    <div class="text-success tg-sm tw-flex tw-items-center tw-gap-1">
      <mat-icon [inline]="true">check_circle</mat-icon>
      Your email address is verified.
    </div>
    } @else {
    <div class="uw-message uw-message-warning uw-message-card">
      <div class="uw-message-title">
        Your email address is not verified.
      </div>
      A verification email has been sent to your email. Please check your inbox
      and click the link in the email to verify your address.
      <div class="uw-message-actions">
        <button mat-flat-button (click)="sendVerificationEmail()" [disabled]="sendingVerificationEmail">
          <mat-icon>forward_to_inbox</mat-icon>
          Resend verification email
        </button>
      </div>
    </div>
    }
    <mat-form-field>
      <mat-label>First Name</mat-label>
      <input matInput id="firstName" name="firstName" [(ngModel)]="user.profile['firstName']" required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Last Name</mat-label>
      <input matInput id="lastName" name="lastName" [(ngModel)]="user.profile['lastName']" required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Phone Number</mat-label>
      <input type="phone" matInput id="phone" name="phone" [(ngModel)]="user.phone" required />
    </mat-form-field>
    <!-- company -->
    <mat-form-field>
      <mat-label>Company or business name</mat-label>
      <input matInput id="company" name="company" [(ngModel)]="user.profile['company']" required />
    </mat-form-field>
    <div class="tw-text-end">
      <button mat-flat-button (click)="updateProfile()" [disabled]="form.invalid || saving">Save</button>
    </div>
    }

  </form>
  }
</div>